export const environment = {
  production: false,
  apiUrl: 'https://panic-be.enetelsolutions.com/',
  webSocketUrl: 'wss://panic-be.enetelsolutions.com/ws/socket',
};
